module.exports = __webpack_public_path__ + "img/home-artwork.047b8115.png";